"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useFlatControllableCheckedItems: function() {
        return useFlatControllableCheckedItems;
    },
    createNextFlatCheckedItems: function() {
        return createNextFlatCheckedItems;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _reactutilities = require("@fluentui/react-utilities");
const _ImmutableMap = require("../../utils/ImmutableMap");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createCheckedItems = require("../../utils/createCheckedItems");
function useFlatControllableCheckedItems(props, headlessTree) {
    return (0, _reactutilities.useControllableState)({
        initialState: _ImmutableMap.ImmutableMap.empty,
        state: _react.useMemo(()=>props.selectionMode ? props.checkedItems && (0, _createCheckedItems.createCheckedItems)(props.checkedItems) : undefined, [
            props.checkedItems,
            props.selectionMode
        ]),
        defaultState: ()=>initializeCheckedItems(props, headlessTree)
    });
}
function createNextFlatCheckedItems(data, previousCheckedItems, headlessTree) {
    if (data.selectionMode === 'single') {
        return _ImmutableMap.ImmutableMap.create([
            [
                data.value,
                data.checked
            ]
        ]);
    }
    const treeItem = headlessTree.get(data.value);
    if (!treeItem) {
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error(`@fluentui/react-tree [useHeadlessFlatTree]:
Tree item ${data.value} not found.`);
        }
        return previousCheckedItems;
    }
    const nextCheckedItems = new Map(previousCheckedItems);
    for (const children of headlessTree.subtree(data.value)){
        nextCheckedItems.set(children.value, data.checked);
    }
    nextCheckedItems.set(data.value, data.checked);
    let isAncestorsMixed = false;
    for (const parent of headlessTree.ancestors(treeItem.value)){
        // if one parent is mixed, all ancestors are mixed
        if (isAncestorsMixed) {
            nextCheckedItems.set(parent.value, 'mixed');
            continue;
        }
        const checkedChildren = [];
        for (const child of headlessTree.children(parent.value)){
            var _nextCheckedItems_get;
            if (((_nextCheckedItems_get = nextCheckedItems.get(child.value)) !== null && _nextCheckedItems_get !== void 0 ? _nextCheckedItems_get : false) === data.checked) {
                checkedChildren.push(child);
            }
        }
        if (checkedChildren.length === parent.childrenValues.length) {
            nextCheckedItems.set(parent.value, data.checked);
        } else {
            // if one parent is mixed, all ancestors are mixed
            isAncestorsMixed = true;
            nextCheckedItems.set(parent.value, 'mixed');
        }
    }
    return _ImmutableMap.ImmutableMap.dangerouslyCreate_unstable(nextCheckedItems);
}
function initializeCheckedItems(props, headlessTree) {
    if (!props.selectionMode) {
        return _ImmutableMap.ImmutableMap.empty;
    }
    let state = (0, _createCheckedItems.createCheckedItems)(props.defaultCheckedItems);
    if (props.selectionMode === 'multiselect') {
        for (const [value, checked] of state){
            state = createNextFlatCheckedItems({
                value,
                checked,
                selectionMode: props.selectionMode
            }, state, headlessTree);
        }
    }
    return state;
}
